import {TeamsManager} from "./teams_manager"
import {TenDLCPartner} from "./ten_dlc_partner"

export class GroupMessagingManager extends HTMLElement {
  constructor(data) {
    super();
    this.data = data;
  }
  connectedCallback() {
    console.log(this.data)
    this.innerHTML = 
      `
      <style>
        group-messaging-manager .nav2-subtabs {
          margin: 8px 0px !important;
          border: none !important;
        }
      </style>
      ${this.data.tnid_partner == null ? `
        <div class="alert alert-info alert-dismissible show" role="alert">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          10DLC is now required to send outbound messages to the US with 10DLC numbers.
          <br>
          *<i>Unregistered 10DLC is at risk of experiencing delivery failures.</i>
        </div>
      ` : ``}
      <h3>Messaging</h3>
      <div>
        <p>Here is where you can manage your Messaging Teams and 10DLC</p>
      </div>
      <div class="nav2-tabs nav2-subtabs page-content-wrap nav" role="tablist" id='tablist2'>
        <a class="active" href="#teams_tab" role="tab" data-toggle="tab">Teams</a>
        <a href="#ten_dlc_partner_tab" role="tab" data-toggle="tab">10DLC</a>
      </div>
      <div class="panel-body tab-content">
        <div class="page-content-wrap nav2-subtabs-item  tab-pane active" id="teams_tab">
        </div>
        <div class="page-content-wrap nav2-subtabs-item  tab-pane active" id="ten_dlc_partner_tab">
          <div class="col-sm-8 no-gutters location-site-attributes">
            ${this.data.tnid_partner == null ? `
            <div class="col-sm-6 no-gutters location-site-attributes">
              <label>10DLC Partner</label>
              <br>
              <span>Provide location info for carrier vetting for 10DLC.</span>
            </div>` : ``}
            <div class="col-sm-6 no-gutters" id="ten_dlc_partner_container">  
            </div>
          </div>
        </div>
      </div>
      `;

    this.querySelector("#ten_dlc_partner_container").appendChild(new TenDLCPartner(this.data));
    this.querySelector("#teams_tab").appendChild(new TeamsManager(this.data));

    $(this).find(".nav2-subtabs a").on("click",function(e){
      $(this).find(".nav2-subtabs a").removeClass("active");
      $(e.target).addClass("active");
      $(this).find(".nav2-subtabs-item").removeClass("active");
      $($(e.target).attr("href")).addClass("active");
      return false;
    }.bind(this));
    this.querySelector('[href="#teams_tab"]').click();
  }
}

customElements.define('group-messaging-manager', GroupMessagingManager)